import React from "react";
import {
	BackgroundDivBgImage,
	BorderedImage,
} from "~/components/.base/containers";
import mmm_sandwich from "~/images/locations/mmm_sandwich.png";
import jim from "~/images/locations/jim-handsopen.png";
import sabin from "~/images/locations/sabin-handsopen.png";
import blurry_tree from "~/images/locations/blurry_tree.png";
import border_white from "~/images/background/border_white.png";
import "./SearchFooter.scss";

const SearchFooter = () => {
	return (
		<div className="search-footer">
			<BorderedImage
				top="-320px"
				topBottomBorder="410px"
				bottom="auto"
				topMobile="-60px"
				topBottomBorderMobile="137px"
			>
				<img src={border_white} alt="border" className="top-border" />
				<img
					src={border_white}
					alt="border"
					className="bottom-border"
				/>
				<BackgroundDivBgImage
					width="100%"
					height="740px"
					heightMobile="200px"
					top="-300px"
					topMobile="-55px"
					color="#edf2f2"
					style={{ zIndex: "-2" }}
				/>
			</BorderedImage>
			<div className="mmm-sandwich">
				<img
					src={mmm_sandwich}
					alt="guy eating sandwich"
					className=""
				/>
			</div>
			<img src={blurry_tree} alt="blurry tree" className="blurry-tree" />
			<img src={jim} alt="jim looking excited!" className="jim" />
			<img src={sabin} alt="sabin looking excited!" className="sabin" />
		</div>
	);
};

export default SearchFooter;
